import React, { Component } from 'react';
import _ from 'lodash';
import { Table, Header, Container } from 'semantic-ui-react';
import UrlHelper from '../../../url-helper';

class DependencyUpgradesSection extends Component
{
    formatDependencyUpgrades( dependencyList, category )
    {
        return _.map(
            dependencyList,
            ( pkg, packageName ) => {
                const url = UrlHelper.getNPMUrl( packageName );

                return (
                    <Table.Row key={packageName}>
                        <Table.Cell><a href={url}>{packageName}</a></Table.Cell>
                        <Table.Cell>{category}</Table.Cell>
                        <Table.Cell>{pkg.current}</Table.Cell>
                        <Table.Cell>{pkg.latest}</Table.Cell>
                    </Table.Row>
                );
            }
        );
    }


    hasDependencyUpgrades()
    {
        return (
            ( _.get( _.keys( this.props.report.data.dependencyUpgrades.dependencies ), 'length', 0 ) > 0 ) ||
            ( _.get( _.keys( this.props.report.data.dependencyUpgrades.devDependencies ), 'length', 0 ) > 0 )
        );
    }


   render()
    {
        if( this.hasDependencyUpgrades() === false )
        {
            return null;
        }

        return (
            <Container className='Dependencies'>
                <Header size={`large`}>Outdated Dependencies</Header>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Package</Table.HeaderCell>
                            <Table.HeaderCell>Category</Table.HeaderCell>
                            <Table.HeaderCell>Current Version</Table.HeaderCell>
                            <Table.HeaderCell>Latest Version</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.formatDependencyUpgrades( this.props.report.data.dependencyUpgrades.dependencies, 'production' )}
                        {this.formatDependencyUpgrades( this.props.report.data.dependencyUpgrades.devDependencies, 'development' )}
                    </Table.Body>
                </Table>
            </Container>
        );
    }
}

export default DependencyUpgradesSection;




// WEBPACK FOOTER //
// ./src/lib/components/PackageView/Sections/DependencyUpgrades.js